import { axios } from "src/common/utils";
import authHeader from "src/common/auth/authHeader";

const UtilsService = {};

UtilsService.GetNotifications = (vatRegistrationNo) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/GetNotifications`,
      data: {
        vatRegistrationNo: vatRegistrationNo,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

UtilsService.SaveFile = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: { "Content-Type": "application/json" },
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/Utility/SaveFile`,
      data: data,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

UtilsService.getFileBase64 = (path) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/Mas/getFileBase64`,
      data: { path: path },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
export default UtilsService;
